import { Box, Typography } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import { abyssColors } from '@/theme/colors';

type Props = {
  onClick: () => void;
};

export const PoiBackButton = ({ onClick }: Props) => (
  <Box
    data-testid="poi-back-button"
    onClick={onClick}
    sx={{
      display: 'flex',
      alignItems: 'center',
      mt: '1.5rem',
      mb: '1.4rem',
      mx: '1.4rem',
      cursor: 'pointer',
      flexShrink: 0,
    }}
  >
    <ArrowBack sx={{ color: abyssColors.primary[500], fontSize: '1.8rem' }} />
    <Typography
      fontSize="1.4rem"
      lineHeight="normal"
      fontWeight={500}
      sx={{ ml: 1 }}
      color={abyssColors.primary[500]}
    >
      All Point of interests
    </Typography>
  </Box>
);
